<template>
  <div class="wenhua" style="padding-top: 50px;">
    <div class="head" style="position: relative">
      <img src="../../static/image/qiyewenhua_title.png" class="fullWidth bgyn" />
      <div class="head-text" style="position: absolute;width:100%">
        <div style="width:100%;">
          <img src="../../static/image/qiyelogo.png" alt />
        </div>
        <p class="head-jj" style="width:100%">
          简云科技以达成企业愿景、践行企业使命为基础，分别代表了新时代背景下，
          <br />对员工、客户、伙伴、社会所表达的态度和肩负的责任
        </p>
      </div>
    </div>
    <div style="position: relative;min-height:700px" class="bjwh">
      <!-- <img src="../../static/image/qiyewenhua_back.png" class="fullWidth bgbanne" /> -->
      <div style="position: absolute;left: 0;top: -222px;right: 0;bottom: 0;">
        <table class="fullWidth" style="height: 100%;">
          <tr>
            <td style="position: relative">
              <Row type="flex" justify="center" class="code-row-bg">
                <Col span="16">
                  <!-- <div class="alignCenter fontfaYahei font36 color33">企业文化</div> -->
                  <div style="height: 50px;"></div>
                  <div v-html="EnterpriseCulture"></div>
                  <div style="height: 85px;"></div>
                  <Row class="code-row-bg">
                    <Col span="6">
                      <div class="fontfaYahei font20 color33">使命</div>
                      <div style="height: 20px;"></div>
                      <div class="fontfaYahei font16 color99">协助客户玩转互联网，迅速做大、做强</div>
                    </Col>
                    <Col span="9" offset="3">
                      <div class="fontfaYahei font20 color33">宗旨</div>
                      <div style="height: 20px;"></div>
                      <div class="fontfaYahei font16 color99">敬畏每一行代码，每一个需求，每一份托付</div>
                    </Col>
                    <Col span="6">
                      <div class="fontfaYahei font20 color33">目标</div>
                      <div style="height: 20px;"></div>
                      <div class="fontfaYahei font16 color99">打造口碑最好的互联网专业技能服务平台</div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="Team_spirit">
      <div class="team_spirit_child">
        <h2>团队精神</h2>
        <ul>
          <li>
            <p class="team_spirit_child_title">团队精神</p>
            <p
              class="team_spirit_child_content"
            >团队精神是大局意识、协作精神和服务精神的集中体现，核心是协同合作，反映的是个体利益和整体利益的统一，并进而保证组织的高效率运转。团队精神,通过合适的组织形态将每个人安排至合适的岗位并充分发挥集体的潜能。</p>
          </li>
          <li>
            <img src="../../static/image/Team_spirit1.png" alt />
          </li>
          <li>
            <div>
              <p class="team_spirit_child_bt">专注</p>
              <p class="team_spirit_child_wz">要求员工集中全部精力去完成一件事，精神贯注</p>
            </div>
          </li>
          <li>
            <img src="../../static/image/Team_spirit2.png" alt />
          </li>
          <li>
            <div>
              <p class="team_spirit_child_bt">勤奋</p>
              <p class="team_spirit_child_wz">认认真真，努力干好一件事情，不怕吃苦，踏实工作</p>
            </div>
          </li>
          <li>
            <div>
              <p class="team_spirit_child_bt">务实</p>
              <p class="team_spirit_child_wz">一指致力于实在的或具体的事情，二指讲究实际</p>
            </div>
          </li>
          <li>
            <img src="../../static/image/Team_spirit3.png" alt />
          </li>
          <li>
            <div>
              <p class="team_spirit_child_bt">担当</p>
              <p class="team_spirit_child_wz">承担、担负任务责任</p>
            </div>
          </li>
          <li>
            <img src="../../static/image/Team_spirit4.png" alt />
          </li>
          <li>
            <div>
              <p class="team_spirit_child_bt">坚毅</p>
              <p class="team_spirit_child_wz">遇到事情坚定而又有毅力</p>
            </div>
          </li>
          <li>
            <img src="../../static/image/Team_spirit5.png" alt />
          </li>
        </ul>
      </div>
    </div>
    <!-- 团队理念 -->
    <div class="teamConcept">
      <h2 class="teamConcept_title">团队理念</h2>
      <p
        class="teamConcept_content"
      >团队理念是简云科技对自己团队成员要达成的目标要求。团队要有共识、共创、共享、共担、共荣五大要求目标。团队要爆发前所未有的潜能，创造出非凡的成果，并且能以合理的成本，高度满足客户的需求。</p>
      <ul :class="colorStyle">
        <li
          v-for="(item,i) in navlist"
          :class="[suoyin === i?'active':'']"
          :key="i"
          @mouseover="hover(i,item)"
          @mouseout="leave(i,item)"
        >
          <img :src="item.icon" alt style="width:80px;height:80px" />
          <span></span>
          <i class="wz1">{{item.content}}</i>
          <i class="wz2">{{item.english}}</i>
        </li>
      </ul>
    </div>
    <Row>
      <Col
        span="6"
        class="curP"
        v-for="(item,index) in bottomList"
        :key="index"
        @mouseenter.native="enterWenhua(index)"
      >
        <div style="position: relative;">
          <img :src="item.icon" class="fullWidth" />
          <div style="position: absolute;left: 0;right: 0;top: 0;bottom: 0;">
            <table class="fullWidth" style="height: 100%;">
              <tr>
                <td align="center" id="mouse_after">
                  <div class="fontfaYahei colorW font36 model">{{item.name}}</div>
                  <div style="height: 10px;"></div>
                  <div class="fontfaYahei colorW font14 model">{{item.subname1}}</div>
                  <div style="height: 10px;"></div>
                  <div class="fontfaYahei colorW font14 model">{{item.subname2}}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </Col>
    </Row>
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }

export default {
  name: "wenhua",
  data() {
    return {
      wenhuaList: [
        {
          title: "初心",
          subname1: "赋能客户借力技术做大做强"
          // subname2: "开放共赢、与合作伙伴分享价值"
        },
        {
          title: "宗旨",
          subname1: "重视每一个需求",
          subname2: "达成每一个托付"
        },
        {
          title: "目标",
          subname1: "打造口碑最后的技术品牌"
          // subname2: "保持专注、持续提升、追求卓越"
        }
      ],
      bottomList: [
        {
          name: "诚信  合作",
          subname1: "始终坚持公正守法、诚实守信",
          subname2: "开放共赢、与合作伙伴分享价值",
          icon: img_url_i + "/static/image/qiyefi.png",
          isShow: false
        },
        {
          name: "高效  进取",
          subname1: "尽职尽责、高效执行、勇于承担",
          subname2: "迎接变化、保持好奇、不断学习",
          icon: img_url_i + "/static/image/qiyefic.png",
          isShow: false
        },
        {
          name: "创新  卓越",
          subname1: "敢于突破、勇于尝试、善于总结",
          subname2: "保持专注、持续提升、追求卓越",
          icon: img_url_i + "/static/image/qiyefia.png",
          isShow: false
        },
        {
          name: "自律  自信",
          subname1: "自律者常自省，自律者常自由",
          subname2: "自信者常沉着，自信者常自强",
          icon: img_url_i + "/static/image/qiyefib.png",
          isShow: false
        }
      ],
      suoyin: "",
      navlist: [
        {
          icon: "../../static/image/teamConcept1.png",
          content: "共识",
          english: "CONSENSUS"
        },
        {
          icon: "../../static/image/teamConcept2.png",
          content: "共创",
          english: "INNOVATE"
        },
        {
          icon: "../../static/image/teamConcept3.png",
          content: "共享",
          english: "SHARE"
        },
        {
          icon: "../../static/image/teamConcept4.png",
          content: "共担",
          english: "ACCEPTANCE"
        },
        {
          icon: "../../static/image/teamConcept5.png",
          content: "共荣",
          english: "KYOEI"
        }
      ],
      colorStyle: "teamConcept_card",
      EnterpriseCulture: ""
    };
  },
  created() {
    this.getEnterpriseCulture();
  },
  methods: {
    enterWenhua(index) {
      var that = this;
      that.bottomList[index].isShow = true;
    },
    hover(index, item) {
      this.suoyin = index;
      if (this.suoyin == index) {
        this.navlist.forEach(itemc => {
          if (item == itemc) {
            itemc.icon =
              "../../static/image/teamConcept1" + (index + 1) + ".png";
          }
        });
      }
    },
    leave(index, item) {
      this.suoyin = index;
      if (this.suoyin == index) {
        this.navlist.forEach(itemc => {
          if (item == itemc) {
            itemc.icon =
              "../../static/image/teamConcept" + (index + 1) + ".png";
          }
        });
      }
      this.suoyin = "";
    },
    getEnterpriseCulture() {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=about_us/getCompanyInfo";
      that.axios
        .get(url, {
          params: {
            type: 2
          }
        })
        .then(res => {
          if (res.data.success) {
            that.EnterpriseCulture = res.data.data;
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bgbanne {
  width: 100%;
  height: 70%;
}
.bjwh {
  background: url("../../static/image/qiyewenhua_back.png") no-repeat top center;
  background-size: 100% 100%;
}
.font16 {
  font-size: 16px;
}
.head-text {
  bottom: 30%;
  text-align: center;
}
.head-jj {
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
  margin-top: 50px;
}
.Team_spirit {
  width: 100%;
  height: 420px;
  background: rgba(240, 243, 246, 1);
  position: relative;
}
.Team_spirit ul {
  list-style: none;
}
.Team_spirit .team_spirit_child {
  width: 1200px;
  height: 460px;
  background: transparent;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -180px;
}
.Team_spirit .team_spirit_child h2 {
  text-align: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.Team_spirit .team_spirit_child ul {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.Team_spirit .team_spirit_child ul li {
  width: 200px;
  height: 200px;
  background: #f89b69;
}
.Team_spirit .team_spirit_child ul li img {
  width: 100%;
  height: 100%;
}
.Team_spirit .team_spirit_child ul li div {
  width: 134px;
  height: 135px;
  margin: 50px auto;
}
.Team_spirit .team_spirit_child ul li div .team_spirit_child_bt {
  text-align: center;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
  margin-top: 45px;
}
.Team_spirit .team_spirit_child ul li div .team_spirit_child_wz {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
  margin-top: 20px;
}
.Team_spirit .team_spirit_child ul li:nth-child(1) {
  width: 400px;
  background: #fff;
  padding: 29px 28px 0 39px;
  box-sizing: border-box;
}
.team_spirit_child_title {
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  position: relative;
}
.team_spirit_child_title::before {
  content: "";
  width: 20px;
  height: 3px;
  background: rgba(253, 123, 53, 1);
  position: absolute;
  bottom: -13px;
  left: 0;
}
.team_spirit_child_content {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
  margin-top: 34px;
}
.teamConcept {
  padding: 20px 0;
  background: #fff;
}
.teamConcept_title {
  text-align: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.teamConcept_content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  margin-top: 38px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(102, 102, 102, 1);
  line-height: 24px;
}
.teamConcept_card {
  list-style: none;
  width: 1200px;
  margin: 90px auto;
  display: flex;
  justify-content: space-between;
}
.teamConcept_card li {
  width: 216px;
  height: 277.8px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 10px 0px rgba(7, 0, 2, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.teamConcept_card li span {
  width: 60px;
  height: 1px;
  background: rgba(253, 123, 53, 1);
}
.teamConcept_card li .wz1 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 24px;
  font-style: normal;
}
.teamConcept_card li .wz2 {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
  opacity: 0.5;
  font-style: normal;
}
.teamConcept_card li.active {
  width: 216px;
  height: 277.8px;
  background: #fd7b35;
  box-shadow: 0px 0px 10px 0px rgba(7, 0, 2, 0.13);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
.teamConcept_card li span {
  width: 60px;
  height: 1px;
  background: #fff;
}
.teamConcept_card li.active .wz1 {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fff;
  line-height: 24px;
  font-style: normal;
}
.teamConcept_card li.active .wz2 {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  line-height: 24px;
  font-style: normal;
}
.ivu-row {
  overflow: hidden;
}
#mouse_after .model {
  opacity: 0;
  /* transform: rotate(-90deg); */
  transform: translateY(1000px);
  overflow: hidden;
  transition: all 0.5s;
}
#mouse_after:hover .model {
  opacity: 1;
  transform: rotate(0);
}
</style>



// WEBPACK FOOTER //
// src/components/wenhua.vue